import React from 'react';
import parse from 'html-react-parser';
import { StyledKBDetail } from './kbDetail.style';
import { Skeleton, Stack } from '@mui/material';

export interface IKBDetailProps {
  kbDetail: any;
  locale?: any;
  isLoading?: boolean;
}

const KBDetail = ({ kbDetail, locale, isLoading }: IKBDetailProps) => {
  if (isLoading) {
    return (
      <Stack direction="column" gap="8px">
        <Skeleton variant="text" width="50%" height={32} />
        <Skeleton variant="text" width="60%" height={22} />
        <Skeleton variant="text" width="40%" height={22} />
        <Skeleton variant="text" width="80%" height={22} />
      </Stack>
    );
  }

  if (!kbDetail?.id) return null;

  return (
    <StyledKBDetail tabIndex={0} role="region" aria-label={locale?.kbContentLabel ?? "Knowledge Article Content"}>
      {parse(kbDetail.content)}
    </StyledKBDetail>
  );
};

export const defaultProps = {
  kbDetail: {},
};
KBDetail.defaultProps = defaultProps;

export default KBDetail;
